import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Button,
  IconButton,
  Typography,
  Divider,
  Checkbox,
  FormControlLabel,
  Paper,
  Box,
} from "@mui/material";
import {
  login,
  forgotPassword,
  isAuthenticated,
} from "../../ApiService/ApiService";
import { isValidEmail } from "../../Utils/validFormDetails";
import { Link, useNavigate } from "react-router-dom";
import SideDesign from "../../static/SideDesign.png";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LoginIcon from "@mui/icons-material/Login";
import ChangePassword from "./ChangePassword";
import ForgotPassword from "./ForgotPassword";
import ReactCardFlip from "react-card-flip";
import CustomDialog from "../../Components/CustomDialog";

function LoginPage() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    schoolId: "",
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [loadingForgotPassword, setLoadingForgotPassword] = useState(false);
  const [isTermsChecked, setIsTermsChecked] = useState(true);
  const [firstTimeLogin, setFirstTimeLogin] = useState(false);
  const [isFlipped, setisFlipped] = useState(false);
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/dashboard");
    }
  }, []);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.schoolId || !formData.email || !formData.password) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please fill in all the details.",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
      return;
    }

    if (!isTermsChecked) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please agree to the terms and conditions.",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
      return;
    }

    if (!isValidEmail(formData.email)) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please enter a valid email.",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
      return;
    }

    setLoading(true);

    try {
      const response = await login(formData);

      if (response && response.status === 200) {
        const { data } = response;

        if (data?.token) {
          const role = data?.roles.includes("ROLE_SUPER_ADMIN")
            ? "ROLE_SUPER_ADMIN"
            : "ROLE_SCHOOL_ADMIN";
          sessionStorage.setItem("role", role);
          sessionStorage.setItem("userId", data?.userId);
          sessionStorage.setItem("schoolId", data?.schoolId);
          sessionStorage.setItem("profileImage", data?.profilePic);

          if (data.isFirstTimeAccess === false) {
            sessionStorage.setItem("firstTimeLogin", "false");
            navigate("/dashboard");
            setFormData({
              schoolId: "",
              email: "",
              password: "",
            });
          } else {
            sessionStorage.setItem("firstTimeLogin", "true");
            setFirstTimeLogin(true);
          }
          return;
        }
      } else if (response && response.status === 401) {
        setDialog({
          visible: true,
          title: "Unauthorized",
          message: "Invalid Credentials",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
      }
    } catch (error) {
      if (error?.response) {
        console.log("Failed to log in!", error?.response?.data);
        setDialog({
          visible: true,
          title: "Unauthorized",
          message: "Invalid Credentials",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
      } else {
        console.log("Failed to log in!", error);
        setDialog({
          visible: true,
          title: "Error",
          message: "An error occurred while logging in.",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!formData.schoolId || !formData.email) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Please fill School Id and Email..",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
      return;
    }
    setLoadingForgotPassword(true);
    try {
      const response = await forgotPassword({
        email: formData.email,
        schoolId: formData.schoolId,
      });
      if (response) {
        if (response?.status === 200) {
          setDialog({
            visible: true,
            title: "Success",
            message: "OTP sent on email",
            buttons: [{ name: "Close", onPress: handleDialogClose }],
          });
          setisFlipped(!isFlipped);
        } else {
          const errorMessage = response?.data?.errorMessage;
          setDialog({
            visible: true,
            title: "Error",
            message: errorMessage,
            buttons: [{ name: "Close", onPress: handleDialogClose }],
          });
        }
      } else {
        setDialog({
          visible: true,
          title: "Error",
          message: "Invalid response from the server",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
      }
    } catch (error) {
      console.log("Error in forgot password", error.response);
      setDialog({
        visible: true,
        title: "Error",
        message: "Error in forgot password",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
    } finally {
      setLoadingForgotPassword(false);
    }
  };

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <Paper
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#e5e5e5",
        }}
      >
        <Navbar showLogin={false} />
        <Paper
          sx={{
            flexGrow: 1,
            p: 3,
            mx: "auto",
            width: "75%",
            boxShadow: "0px 4px 100px rgba(0, 0, 0, 0.1)",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              md={6}
              lg={6}
              xl={6}
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              sx={{ pr: 3 }}
            >
              <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
                <>
                  {firstTimeLogin === true ? (
                    <ChangePassword setFirstTimeLogin={setFirstTimeLogin} />
                  ) : (
                    <Paper
                      elevation={3}
                      sx={{
                        padding: 5,
                        boxShadow: "0px 4px 80px rgba(0, 0, 0, 0.1)",
                        ml: 5,
                      }}
                    >
                      <form
                        onSubmit={handleSubmit}
                        style={{ display: "block" }}
                      >
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          Login
                        </Typography>
                        <Divider sx={{ p: 1 }} />
                        <Typography
                          variant="h6"
                          sx={{ color: "gray", textAlign: "center" }}
                        >
                          Welcome to{" "}
                          <span
                            style={{
                              color: "black",
                              fontWeight: "bold",
                              fontSize: "18px",
                            }}
                          >
                            SchoolMidas
                          </span>
                        </Typography>

                        <TextField
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          size="small"
                          label="School ID"
                          name="schoolId"
                          placeholder="Eg. SMS-123"
                          value={formData.schoolId}
                          onChange={handleChange}
                          required
                        />
                        <TextField
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Email"
                          name="email"
                          placeholder="Eg. john@gmail.com"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                        <TextField
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Password"
                          type={showPassword ? "text" : "password"}
                          name="password"
                          placeholder="Eg. john123@#$"
                          value={formData.password}
                          onChange={handleChange}
                          InputProps={{
                            endAdornment: (
                              <IconButton onClick={handleTogglePassword}>
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            ),
                          }}
                          required
                        />

                        <Button
                          sx={{ textTransform: "unset", float: "right" }}
                          onClick={handleForgotPassword}
                          disabled={loadingForgotPassword}
                        >
                          {loadingForgotPassword
                            ? "Loading..."
                            : "Forgot Password ?"}
                        </Button>

                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isTermsChecked}
                              onChange={(event) =>
                                setIsTermsChecked(event.target.checked)
                              }
                            />
                          }
                          label={
                            <Typography sx={{ fontSize: "14px" }}>
                              I agree to SchoolMidas's {""}
                              <Link
                                to="#terms"
                                target="_blank"
                                rel="noopener noreferrer"
                                color="inherit"
                                style={{ textDecoration: "none" }}
                              >
                                T&C
                              </Link>{" "}
                              and
                              <Link
                                to="#privacy"
                                target="_blank"
                                rel="noopener noreferrer"
                                color="inherit"
                                style={{ textDecoration: "none" }}
                              >
                                {" "}
                                Privacy Policy
                              </Link>
                            </Typography>
                          }
                        />

                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          fullWidth
                          sx={{ textTransform: "unset", mt: 2, height: "50px" }}
                          disabled={
                            loading || !isTermsChecked || !formData.password
                          }
                        >
                          {loading ? "Loading..." : "Login"}{" "}
                          <LoginIcon fontSize="small" sx={{ ml: 1 }} />
                        </Button>
                      </form>
                    </Paper>
                  )}
                </>
                <>
                  <ForgotPassword
                    email={formData.email}
                    schoolId={formData.schoolId}
                    isFlipped={isFlipped}
                    setisFlipped={setisFlipped}
                  />
                </>
              </ReactCardFlip>
            </Grid>

            <Grid
              item
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              md={6}
              lg={6}
              xl={6}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "flex",
                  lg: "flex",
                  xl: "flex",
                },
              }}
            >
              <img
                src={SideDesign}
                alt="background"
                style={{ width: "500px", height: "auto" }}
              />
            </Grid>
          </Grid>
        </Paper>
        <Footer />
      </Paper>
    </>
  );
}

export default LoginPage;
